import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CssService } from 'src/app/services/css-service';

export interface InfoDialogData {
  title: string;
  message: string;
  isError?: boolean;
}

@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.css']
})
export class InfoDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<InfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InfoDialogData,
    public cssService: CssService,
  ) {}

  isClosing = false;
  selectedOption: string | null = null;

  onClose() {
    this.selectedOption = null;
    this.isClosing = true;
  }

  onAnimationEnd() {
    if (this.isClosing)
      this.dialogRef.close(this.selectedOption);
  }
}
